// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Admin: access requests
 */

.AccessRequests_page__Tmmrf {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: var(--space-6) var(--gutter) var(--space-16);
  box-sizing: border-box;
}

.AccessRequests_header__FRZ\\+y {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.AccessRequests_headerText__\\+eXPW {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.AccessRequests_title__fZTTY {
  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  color: var(--text-primary);
}

.AccessRequests_subtitle__sdWmv {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
  max-width: 62ch;
}

.AccessRequests_list__kV94L {
  list-style: none;
  margin: 0;
  padding: 0;
}

.AccessRequests_row__72Edj {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--border-light);
}

.AccessRequests_row__72Edj:last-child {
  border-bottom: none;
}

.AccessRequests_who__1AGDF {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 240px;
  min-width: 0;
}

.AccessRequests_email__5NPSP {
  font-weight: 600;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.AccessRequests_meta__bimXn {
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.AccessRequests_actions__PEtZZ {
  display: flex;
  gap: var(--space-2);
  margin-left: auto;
}

.AccessRequests_empty__WkRNN {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-4) 0;
  color: var(--text-secondary);
}

@media (max-width: 560px) {
  .AccessRequests_page__Tmmrf {
    padding: var(--space-5) var(--gutter) var(--space-12);
  }

  .AccessRequests_actions__PEtZZ {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Admin/AccessRequests.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qDAAqD;EACvD;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/*\n * Admin: access requests\n */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: var(--space-6) var(--gutter) var(--space-16);\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n}\n\n.headerText {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.title {\n  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  color: var(--text-primary);\n}\n\n.subtitle {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  max-width: 62ch;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  padding: var(--space-3) 0;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.row:last-child {\n  border-bottom: none;\n}\n\n.who {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1 1 240px;\n  min-width: 0;\n}\n\n.email {\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n}\n\n.meta {\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.actions {\n  display: flex;\n  gap: var(--space-2);\n  margin-left: auto;\n}\n\n.empty {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-4) 0;\n  color: var(--text-secondary);\n}\n\n@media (max-width: 560px) {\n  .page {\n    padding: var(--space-5) var(--gutter) var(--space-12);\n  }\n\n  .actions {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AccessRequests_page__Tmmrf`,
	"header": `AccessRequests_header__FRZ+y`,
	"headerText": `AccessRequests_headerText__+eXPW`,
	"title": `AccessRequests_title__fZTTY`,
	"subtitle": `AccessRequests_subtitle__sdWmv`,
	"list": `AccessRequests_list__kV94L`,
	"row": `AccessRequests_row__72Edj`,
	"who": `AccessRequests_who__1AGDF`,
	"email": `AccessRequests_email__5NPSP`,
	"meta": `AccessRequests_meta__bimXn`,
	"actions": `AccessRequests_actions__PEtZZ`,
	"empty": `AccessRequests_empty__WkRNN`
};
export default ___CSS_LOADER_EXPORT___;
